/* eslint-disable consistent-return */
export const evaluateMinor = {
  computed: {
    evaluateMinor() {
      if (!this.minor || !this.minor.status) {
        return '';
      }
      if (this.minor.status === 'left') {
        return 'grey-darkest';
      }
      if (
        this.minor.status === 'warning' &&
        this.minor.status_description === 'minor_warning'
      ) {
        return 'orange';
      }
      if (this.minor.status === 'ok') {
        if (this.minor.status_description === 'minor_not_yet_expected') {
          return 'blue';
        }
        if (this.minor.status_description === 'qr_arrived') {
          return 'blinkingBlue';
        }
        if (
          this.minor.status_description === 'emergency_call_answered' ||
          this.minor.status_description === 'absence_expected' ||
          this.minor.status_description === 'minor_absent_by_teacher'
        ) {
          return 'purple';
        }
        if (
          this.minor.status_description === 'still_closed' ||
          this.minor.status_description === 'day_of_closure'
        ) {
          return 'grey';
        }
        return 'green';
      }
      if (this.minor.status === 'danger') {
        if (
          this.minor.status_description === 'minor_max_danger' ||
          this.minor.status_description === 'no_tutor_answered'
        ) {
          return 'flipDanger';
        }
        return 'red';
      }
      return '';
    },
  },
};

export const showMinorMessage = {
  computed: {
    showMessage() {
      if (!this.minor || !this.minor.status_description || !this.minor.status) {
        return '';
      }
      if (this.minor.status_description === 'minor_not_yet_expected') {
        return `${this.$t('all.waiting_to_enter')}`;
      }
      if (this.minor.status_description === 'qr_arrived') {
        return `${this.$t('all.present_to_family')}`;
      }
      if (this.minor.status_description === 'minor_in_class') {
        return `${this.$t('all.present')}`;
      }
      if (this.minor.status_description === 'minor_warning') {
        return `${this.$t('all.on_hold')}`;
      }
      if (this.minor.status_description === 'minor_danger') {
        return `${this.$t('all.attention')}`;
      }
      if (this.minor.status_description === 'minor_max_danger') {
        return `${this.$t('all.attention')}`;
      }
      if (
        this.minor.status_description === 'emergency_call_answered' ||
        this.minor.status_description === 'absence_expected' ||
        this.minor.status_description === 'minor_absent_by_teacher'
      ) {
        return '-';
      }
      if (this.minor.status === 'left') {
        return `${this.$t('all.exit')}`;
      }
      if (
        this.minor.status_description === 'still_closed' ||
        this.minor.status_description === 'day_of_closure'
      ) {
        return `${this.$t('all.closed_school')}`;
      }
    },
  },
};

export const getMinorTimeLimit = {
  computed: {
    getTimeLimit() {
      if (!this.minor || !this.minor.status_time) {
        return '-';
      }
      if (this.minor.status_time) {
        const time = this.minor.status_time.split(':');
        const hour = time[0] + ':' + time[1];
        if (this.minor.status_description === 'qr_arrived') {
          return `${this.$t('all.entered_at')} ${hour}`;
        }
        if (this.minor.status_description === 'minor_in_class') {
          return `${this.$t('all.entered_at')} ${hour}`;
        }
        if (this.minor.status === 'left') {
          return `${this.$t('all.released_at')} ${hour}`;
        }
        if (this.minor.status_description === 'qr_arrived') {
          return `${this.$t('all.entered_at')} ${hour}`;
        }
        if (this.minor.status_description === 'minor_in_class') {
          return `${this.$t('all.entered_at')} ${hour}`;
        }
      }
      if (this.minor.arrival_time_today) {
        const arrivalTime = this.minor.arrival_time_today.split(':');
        const arrivalHour = arrivalTime[0] + ':' + arrivalTime[1];
        if (this.minor.status_description === 'minor_not_yet_expected') {
          return `${this.$t('all.time_limit')} ${arrivalHour}`;
        }
        if (this.minor.status_description === 'minor_warning') {
          return `${this.$t('all.time_limit')} ${arrivalHour}`;
        }
        if (this.minor.status_description === 'minor_not_yet_expected') {
          return `${this.$t('all.time_limit')} ${arrivalHour}`;
        }
        if (this.minor.status_description === 'minor_warning') {
          return `${this.$t('all.time_limit')} ${arrivalHour}`;
        }
      }
      if (
        this.minor.status_description === 'emergency_call_answered' ||
        this.minor.status_description === 'absence_expected' ||
        this.minor.status_description === 'minor_absent_by_teacher'
      ) {
        return `${this.$t('all.absent_justified')}`;
      }
      if (
        this.minor.status_description === 'still_closed' ||
        this.minor.status_description === 'day_of_closure'
      ) {
        return '-';
      }
      if (this.minor.status_description === 'minor_absent_by_teacher') {
        return '';
      }
      return '-';
    },
  },
};
